import React, { useEffect, useState } from "react"
import MultiSelect from "../../../components/atoms/MultiSelect.atom"

const TaskStateDropdown = ({ states, selectedStates, setSelectedStates }) => {
  const [label, setLabel] = useState("Estados: Todos")
  const id = `task-state-picker-${new Date().getTime()}`
  useEffect(() => {
    if (selectedStates.length === 0) {
      setLabel("Estados: Todos")
    } else if (selectedStates.length === 1) {
      const name = states.find(
        (member) => member.value === selectedStates[0]
      ).label
      setLabel(name)
    } else if (selectedStates.length < states.length) {
      setLabel(`${selectedStates.length} integrantes seleccionados`)
    } else if (selectedStates.length === states.length) {
      setLabel("Estados: Todos")
    }
  }, [selectedStates])

  const labelTemplate = () => {
    return (
      <span>
        <i className="pi pi-check-circle mr-2"></i>
        {label}
      </span>
    )
  }
  return (
    <MultiSelect
      inputId={id}
      className="team-member-picker"
      value={selectedStates}
      options={states}
      onChange={(e) => setSelectedStates(e.value)}
      optionLabel="label"
      optionValue="value"
      placeholder={labelTemplate()}
      maxSelectedLabels={0}
      selectedItemsLabel={labelTemplate()}
      scrollHeight="417px"
      panelClassName="max-w-23rem"
    />
  )
}

export default TaskStateDropdown
